import { TreeNodeExpansionWidth } from 'shared/data_tree/styled';
import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

export type TreeItemContainerProps = Readonly<{
    $isSelectable: boolean;
    $isContextMenuOpen: boolean;
}>;

export const TreeItemContainer = styled.div<TreeItemContainerProps>`
    font-size: 1.4rem;
    display: flex;
    flex: 1;
    min-width: 0;
    gap: 0.25rem;
    align-items: center;
    cursor: ${({ $isSelectable }) => ($isSelectable ? 'inherit' : 'not-allowed')};
    border: 1px solid
        ${({ $isContextMenuOpen }) =>
            $isContextMenuOpen ? tokens.border.focus : 'transparent'};
`;

export type TreeItemGroupLabelProps = Readonly<{
    $isSelected?: boolean;
    $isDisabled?: boolean;
}>;

const getTreeItemLabelColor = ({ $isDisabled, $isSelected }: TreeItemGroupLabelProps) => {
    if ($isSelected) {
        return tokens.on.primary;
    }

    if ($isDisabled) {
        return tokens.text.disabled;
    }

    return undefined;
};

export const TreeItemGroupLabel = styled.div<TreeItemGroupLabelProps>`
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
    padding: 0.15rem 0.5rem;
    background-color: ${({ $isSelected }) =>
        $isSelected ? tokens.text.link : undefined};
    color: ${(props) => getTreeItemLabelColor(props)};
`;

export const TreeItemIcons = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
`;

export const TreeItemGroupLabelIcon = styled.div<{ $hasIcon?: boolean }>`
    display: flex;
    align-items: center;
    ${({ $hasIcon }) =>
        $hasIcon
            ? css`
                  width: ${TreeNodeExpansionWidth};
                  padding-right: 0.5rem;
              `
            : ''};
`;

export type TreeItemGroupLabelTextProps = Readonly<{
    $isRoot: boolean;
}>;

export const TreeItemGroupLabelText = styled.div<TreeItemGroupLabelTextProps>`
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${({ $isRoot }) => ($isRoot ? '500' : undefined)};
`;

export const TreeItemMovePreview = styled.div`
    background-color: ${tokens.surface.dark};
    color: ${tokens.foreground.inverse};
    padding: 0.5rem 1rem;
    margin-left: 2rem;
    font-size: 1.4rem;
`;
